






















































import Vue from 'vue';
import { mapState } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import { AppScope } from '../../../constants/appScope';
import { PaymentSystem } from '../../../constants/paymentSystem';
import { HotelInterface } from '../../../types/hotelInterface';
import hashBookingDataMixin from '../../../mixins/hashBookingData';
import { RatePlanInterface, RoomDataInterface } from '@/types/store/landing/hotels/roomDataInterface';
import { BookingDetailsInterface } from '@/types/store/landing/booking/bookingDetailsInterface';
import { PaymentMethods } from '@/constants/paymentMethods';
import { BookingDataInterface } from '@/types/store/landing/booking/bookingDataInterface';
import { HotelDataInterface } from '@/types/store/landing/hotels/hotelDataInterface';
import { PrefectureInterface } from '@/types/common/prefectureInterface';
import { MealOptions } from '@/constants/mealOption';

export default Vue.extend({
  name: 'BookingDetails',
  props: {
    header: {
      type: String,
      default: 'room-preview',
    },
    hasMobileMode: {
      type: Boolean,
      default: true,
    },
    initBooking: {
      type: Object,
    },
  },
  mixins: [hashBookingDataMixin],
  data: () => ({
    cancellationOpen: false,
    detailsOpen: false,
    percent: 3,
  }),
  computed: {
    isDashboard(): boolean {
      const scope = this.getScope();
      return scope === AppScope.Dashboard;
    },
    ...mapState({
      prefectures(state: any): PrefectureInterface {
        return this.isDashboard ? state.dashboard.settings.prefectures : state.landing.settings.prefectures;
      },
      dashboardHotel(state: any): HotelInterface {
        return state.dashboard.hotel;
      },
      paymentSystem(state: any): PaymentSystem {
        return (this as any).isDashboard
          ? state.dashboard.settings.payment_system
          : state.landing.settings.payment_system;
      },
      landingHotel: (state: any): HotelDataInterface => state.landing.hotel.item,
      landingRoomType: (state: any): RoomDataInterface => state.landing.hotel.room,
      initialBooking: (state: any): BookingDataInterface => state.landing.booking.initial,
      bookingData: (state: any): BookingDataInterface => state.landing.booking.data,
      bookingDetails: (state: any): BookingDetailsInterface => state.landing.booking.bookingDetails,
    }),
    mealOption(): MealOptions {
      const mealOption: number =
        this.initBooking && this.initBooking.meal_options
          ? this.initBooking.meal_options.length
          : this.booking.meal_option;
      switch (mealOption) {
        case 1:
          return MealOptions.with_breakfast;
        case 2:
          return MealOptions.breakfast_with_dinner;
        default:
          return MealOptions.no_meals;
      }
    },
    guaranteeType(): PaymentMethods {
      return this.initBooking ? this.initBooking.guarantee_type : this.bookingDetails.payment_method;
    },
    isStripe(): boolean {
      return this.paymentSystem === PaymentSystem.Stripe;
    },
    hotel(): HotelInterface {
      return this.isDashboard ? this.dashboardHotel : this.landingHotel;
    },
    roomType(): RoomDataInterface {
      return this.initBooking ? this.initBooking.room_type : this.landingRoomType;
    },
    hotelName(): string {
      return this.hotel.name[this.i18nTag()] ? this.hotel.name[this.i18nTag()] : this.hotel.name.en;
    },
    hotelAddress(): string {
      return this.hotel.address[this.i18nTag()] ? this.hotel.address[this.i18nTag()] : this.hotel.address.en;
    },
    hotelAddressLink(): string {
      const lat = this.hotel.latitude;
      const lng = this.hotel.longitude;
      return `dir//${lat},${lng}/@${lat},${lng},12z`;
    },
    hotelAddressFormatted(): string {
      let prefecture: any = '';
      if (this.hotel.prefecture_code) {
        prefecture = this.prefectures[this.hotel.prefecture_code];
        if (prefecture) {
          prefecture = this.$t('common.prefecture.' + prefecture);
        }
      }
      if (this.$i18n.locale === 'en') {
        return prefecture ? `${this.hotelAddress}, ${prefecture}` : this.hotelAddress;
      }
      return `${prefecture}${this.hotelAddress}`;
    },
    roomName(): string {
      if (!this.roomType || !this.roomType.name) {
        return '';
      }
      return this.roomType.name[this.i18nTag()] ? this.roomType.name[this.i18nTag()] : this.roomType.name.en;
    },
    roomPhoto(): string {
      let photos = this.roomType && this.roomType.images ? this.roomType.images : [];
      photos = JSON.parse(JSON.stringify(photos));
      photos = photos.sort((a: any, b: any) => (a.position > b.position ? 1 : -1));
      return photos[0] && photos[0].thumbnail ? photos[0].thumbnail : '';
    },
    paymentSuccess(): boolean {
      return this.$route.path === '/payment/success';
    },
    booking(): BookingDataInterface {
      if (this.initBooking) {
        return this.initBooking;
      }
      return this.bookingData;
    },
    bookingNights(): string | TranslateResult {
      const count = this.nightsCount(this.booking.checkin, this.booking.checkout);
      return count === 1 ? this.$t('booking-night') : this.$t('num-of-nights', { nights: count });
    },
    translationParams(): any {
      return this.hotel.cancellation_policy ? this.hotel.cancellation_policy : {};
    },
    isFreeCancellation(): boolean {
      return this.translationParams.default_rate == 0;
    },
    showRoomPreview(): boolean {
      return this.header === 'room-preview';
    },
    showHotelInfo(): boolean {
      return this.header === 'hotel-info';
    },
    bookingPrice(): number {
      if (this.roomType) {
        const plan: RatePlanInterface[] = this.filterRatePlan(
          this.roomType.rate_plans as RatePlanInterface[],
          this.booking.meal_option,
          this.guaranteeType,
        );
        if (plan.length) {
          return plan[0].amount;
        }
      }
      return 0;
    },
  },
});
